import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { VdoIconComponent } from 'ui-kit';

@Component({
  selector: 'vdo-map-icon-marker',
  imports: [VdoIconComponent],
  templateUrl: './vdo-map-icon-marker.component.html',
  styleUrl: './vdo-map-icon-marker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VdoMapIconMarkerComponent {
  icon = input('arrow-up');
  angle = input(0);
  sizeIcon = input(20);
  sizeMarker = input(40);
  displayFloatingIcon = input(false);
  private _isOn = true;
  private _displayShadow = true;
  private _selected = false;

  @Input()
  set isOn(value: boolean | string) {
    this._isOn =
      typeof value === 'string'
        ? value.toLowerCase() === 'on' || value.toLowerCase() === 'true'
        : value;
  }

  get isOn(): boolean {
    return this._isOn;
  }

  @Input()
  set displayShadow(value: boolean | string) {
    this._displayShadow =
      typeof value === 'string'
        ? value.toLowerCase() === 'on' || value.toLowerCase() === 'true'
        : value;
  }

  get displayShadow(): boolean {
    return this._displayShadow;
  }

  @Input()
  set selected(value: boolean | string) {
    this._selected =
      typeof value === 'string'
        ? value.toLowerCase() === 'on' || value.toLowerCase() === 'true'
        : value;
  }

  get selected(): boolean {
    return this._selected;
  }

  protected getRotation(): string {
    return `rotate(${this.angle()}deg)`;
  }
}
